(() => {
  const initialize = () => {
    document.querySelectorAll('[data-emb-exact-variant]').forEach((select) => {
      if (select.dataset.embExactReady === 'true') return;
      select.dataset.embExactReady = 'true';

      const productInfo = select.closest('product-info');
      const form = select.form;
      const submit = form?.querySelector('[type="submit"][name="add"]');
      const price = productInfo?.querySelector('.price-item--regular');
      const bundleLink = productInfo?.querySelector('[data-emb-add-to-bundle]');

      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;

        const available = option.dataset.available === 'true';
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (submit) submit.disabled = !available;

        const productUrl = productInfo?.dataset.url;
        if (productUrl && option.value) {
          window.history.replaceState({}, '', `${productUrl}?variant=${option.value}`);
        }
        if (bundleLink && option.value) {
          const destination = new URL(bundleLink.href, window.location.origin);
          destination.searchParams.set('variant', option.value);
          bundleLink.href = `${destination.pathname}${destination.search}`;
        }

        document.dispatchEvent(new CustomEvent('embrynium:variant:selected', {
          detail: {
            variantId: option.value,
            title: option.textContent.trim(),
            available,
          },
        }));
      };

      select.addEventListener('change', update);
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

(() => {
  const initializeProductMedia = () => {
    document.querySelectorAll('product-info[data-product-id]').forEach((productInfo) => {
      if (productInfo.dataset.embMediaReady === 'true') return;
      const sectionId = productInfo.dataset.section;
      const state = window.EmbryniumProductState?.read(`EmbProductConfig-${sectionId}`);
      const controls = productInfo.querySelector('[data-emb-pdp-view]');
      if (!state || !controls) return;

      productInfo.dataset.embMediaReady = 'true';
      let view = state.product.defaultView || 'front';

      const selectedOptions = () => {
        const picker = productInfo.querySelector('variant-selects');
        if (!picker) return state.variants.find((item) => item.available)?.options || state.variants[0]?.options || [];
        return [...picker.querySelectorAll('.product-form__input')].map((group) => {
          const checked = group.querySelector('input[type="radio"]:checked');
          const select = group.querySelector('select');
          return checked?.value || select?.value || '';
        });
      };

      const render = () => {
        const selection = selectedOptions();
        const variant = state.resolveVariant(selection);
        const media = state.resolveMedia({ selection, view, variant });
        controls.querySelectorAll('[data-emb-product-view]').forEach((button) =>
          button.setAttribute('aria-pressed', String(button.dataset.embProductView === view))
        );
        const gallery = productInfo.querySelector('media-gallery');
        if (gallery && media) {
          const mediaId = `${sectionId}-${media.id}`;
          if (typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(mediaId, false);
          } else {
            const activeMedia = gallery.querySelector(`[data-media-id="${mediaId}"]`);
            if (activeMedia) {
              gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.remove('is-active'));
              activeMedia.classList.add('is-active');
              activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
          }
        }

        const bundleLink = productInfo.querySelector('.emb-product-bundle-offer a');
        if (bundleLink && variant?.id) {
          const destination = new URL(bundleLink.href, window.location.origin);
          destination.searchParams.set('product', state.product.handle);
          destination.searchParams.set('variant', variant.id);
          bundleLink.href = `${destination.pathname}${destination.search}`;
        }
      };

      controls.querySelectorAll('[data-emb-product-view]').forEach((button) => {
        button.addEventListener('click', () => {
          view = button.dataset.embProductView;
          render();
        });
      });
      productInfo.addEventListener('change', (event) => {
        if (!event.target.closest('variant-selects')) return;
        window.setTimeout(render, 120);
        window.setTimeout(render, 420);
      });
      render();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductMedia, { once: true });
  } else {
    initializeProductMedia();
  }
  document.addEventListener('shopify:section:load', initializeProductMedia);
})();
